module.exports = __webpack_public_path__ + "img/data3-1.6a99302f.png";